import { useEffect } from "react";

/**
 * Lightweight SEO component — sets document title, meta tags, and JSON-LD schema.
 * No external dependency. Removes injected JSON-LD on unmount.
 */
export default function Seo({
  title,
  description,
  image,
  type = "website",
  schema, // optional JSON-LD object or array
}) {
  useEffect(() => {
    if (title) document.title = title;
    setMeta("description", description);
    setMeta("og:title", title, true);
    setMeta("og:description", description, true);
    setMeta("og:type", type, true);
    setMeta("og:site_name", "Voyage Luxe", true);
    if (image) setMeta("og:image", image, true);
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
    if (image) setMeta("twitter:image", image);

    let scriptEl = null;
    if (schema) {
      scriptEl = document.createElement("script");
      scriptEl.type = "application/ld+json";
      scriptEl.id = "vl-jsonld";
      scriptEl.text = JSON.stringify(schema);
      const existing = document.getElementById("vl-jsonld");
      if (existing) existing.remove();
      document.head.appendChild(scriptEl);
    }
    return () => {
      if (scriptEl?.parentNode) scriptEl.parentNode.removeChild(scriptEl);
    };
  }, [title, description, image, type, schema]);
  return null;
}

function setMeta(name, content, isProperty = false) {
  if (!content) return;
  const attr = isProperty ? "property" : "name";
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}
